<template>
  <div class="starry-night">
    <div :style="{ transform: `translateY(${this.offset}px)` }">
      <img :src="stars" />
      <img :src="stars" />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    stars: "",
    offset: 0
  }),

  mounted() {
    this.drawStars()

    // debounce resize
    let timeoutID
    window.addEventListener("resize", () => {
      clearTimeout(timeoutID)
      timeoutID = setTimeout(this.drawStars, 100)
    })

    window.addEventListener("scroll", this.onScroll)
  },

  methods: {
    drawStars() {
      const cv = document.createElement("canvas")
      const ctx = cv.getContext("2d")

      const width = window.innerWidth
      const height = window.innerHeight

      const dpr = window.devicePixelRatio
      cv.width = dpr * width
      cv.height = dpr * height
      ctx.scale(dpr, dpr)

      ctx.fillStyle = "#fff"

      const numStars = 0.0003 * width * height
      for (let i = 0; i < numStars; i++) {
        const x = Math.random() * width
        const y = Math.random() * height
        const r = 1 + 2 * Math.random()

        ctx.globalAlpha = 0.2 + 0.3 * Math.random()
        ctx.fillRect(x, y, r, r)
      }

      this.stars = cv.toDataURL()
    },

    onScroll() {
      this.offset = (-0.2 * window.scrollY) % window.innerHeight
    }
  }
}
</script>

<style lang="scss">
.starry-night {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(rgba($blue, 0.2), rgba($blue, 0));

  img {
    pointer-events: none;
    width: 100%;
    height: 100%;
    filter: blur(1px);
  }
}
</style>
